








import Vue from 'vue';
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiCard from "@/components/common/AsiCard.vue";
import {getMonday, isSameDay, toISODateString} from "@/helpers/functions_asi";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiConfirmDialog from "@/components/common/AsiConfirmDialog.vue";
import DailyPlanningData from "@/models/DailyPlanningData";
import DailyOverview from "@/components/planning/DailyOverview.vue";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import PaginatedResponse from "@/models/PaginatedResponse";
import CompanySimple from "@/models/company/CompanySimple";
import OrderSimple from "@/models/order/OrderSimple";

@Component({
	components: {DailyOverview, AsiConfirmDialog, AsiBtn, AsiAvatar, AsiCard, AsiContentContainer}
})
export default class WeeklyOverview extends Vue {

	@Prop({type: Object, default: null})
	public company!: CompanySimple | null;

	@Prop({type: Object, default: null})
	public order!: OrderSimple | null;

	@Prop({type: Date, required: true})
	public date!: Date;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	private weekData: DailyPlanningData[] = [];
	private planningEntries: PlanningEntryListEntry[] = [];
	private dateFrom: Date | null = null;
	private dateTo: Date | null = null;

	public created(): void {
		this.setDateBoundaries();
		this.fetchData();
	}

	@Emit('loadingChanged')
	public loadingChanged(loading: boolean): boolean {
		return loading;
	}

	@Emit('planningEntriesChanged')
	public planningEntriesChanged(): void {
		this.setDateBoundaries();
		this.fetchData();
	}

	private prepareWeekData(): void {
		if (this.dateFrom === null || this.dateTo === null) return;
		this.weekData = [];

		let curDay = new Date(this.dateFrom);
		for (let i = 0; i < 7; i++) {
			const entries = this.planningEntries.filter(e => {
				return isSameDay(new Date(e.date), curDay);
			});
			this.weekData.push(new DailyPlanningData(curDay, entries));

			const newDay = new Date(curDay);
			newDay.setDate(curDay.getDate() + 1);
			curDay = newDay;
		}
	}

	private fetchData(): void {
		if (this.dateFrom === null || this.dateTo === null) return;

		const filter = new PlanningEntryListFilter();
		filter.dateFrom = toISODateString(this.dateFrom);
		filter.dateTo = toISODateString(this.dateTo);

		this.loadingChanged(true);
		if (this.company === null) {
			this.$planningEntryService.planningEntries(filter, null)
				.then((res: PaginatedResponse<PlanningEntryListEntry>) => {
					this.planningEntries = res.data;
					this.prepareWeekData();
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.loadingError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => this.loadingChanged(false));
		} else {
			this.$companyService.planningEntries(this.company.id, filter, null)
				.then((res: PaginatedResponse<PlanningEntryListEntry>) => {
					this.planningEntries = res.data;
					this.prepareWeekData();
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.loadingError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => this.loadingChanged(false));
		}

	}

	private setDateBoundaries(): void {
		this.dateFrom = getMonday(this.date);
		this.dateTo = new Date(this.dateFrom);
		this.dateTo.setDate(this.dateTo.getDate() + 6);
	}

	@Watch('date')
	private onDateChanged(): void {
		this.setDateBoundaries();
		this.fetchData();
	}

	@Watch('order', {deep: true})
	private onOrderChanged(): void {
	    this.fetchData();
	}

	@Watch('company', {deep: true})
	private onCompanyChanged(): void {
	    this.fetchData();
	}

}
